import React from 'react';
import {
    Box,
    Stack,
    TextField,
    Button,
    Grid,
    InputLabel,
    Select,
    MenuItem,
    Typography,
    Chip,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    useTheme,
} from '@mui/material';
import TagEditor from './TagEditor';
import { PagePanel, PageHeading } from 'Components/Styled';
import { CustomerName } from 'Modules/Components/CustomerName';
import moment from 'moment';
import * as CustomerApi from '../../../Services/CustomerApi';
import { useFormState, Controller, FormProvider, useForm } from 'react-hook-form';
import { isEmpty } from 'lodash';
import { TagsContext } from 'Modules/Components/TagsContext';


function mapCustomerToProfileForm(customer) {
   
    const formData = {
        lifeStage : customer.internalProfile?.lifeStage || '',
        lifeSituation : customer.internalProfile?.lifeSituation || '',
        internalProfileNotes : customer.internalProfile?.internalProfileNotes || '',
        tags : parseStringToTags(customer.internalProfile?.tagString || '{}'),
    };
    return formData;
}


export default function CustomerProfile({ customer }) {
    console.log('profile render',  {profile : customer})

    const { tagList } = React.useContext(TagsContext);
    const [visibleTags, setVisibleTags] = React.useState({});
    const customerProfileForm = useForm({ defaultValues: mapCustomerToProfileForm(customer)});
    const [openEditModal, setOpenEditModal] = React.useState(false);
    const handleOpen = () => setOpenEditModal(true);
    const handleClose = () => setOpenEditModal(false);
    const { isDirty } = useFormState({ control : customerProfileForm.control });
    const selectedTags = customerProfileForm.getValues('tags');

    React.useEffect(() => {
        customerProfileForm.reset(mapCustomerToProfileForm(customer))
    }, [customer, customerProfileForm]);

    React.useEffect(() => {
        const visible = {};
        Object.keys(tagList).forEach((category) => {
            if (category === 'Milestones') return;
            visible[category] = selectedTags?.[category]?.map((id) => tagList[category].find((t) => t.id === id));
        });
        setVisibleTags(visible);
    }, [selectedTags, tagList, customerProfileForm, isDirty])

    async function onFormSubmit(formData) { 
        const submitData = {...formData, tagString : parseTagsToString(formData.tags)}
        console.log('MEXsubmit', {formData})
        try {
            if (!customer.profile.id) {
                throw new Error('Invalid customer record.  No ID found');
             }
            const updatedProfile = await CustomerApi.saveInternalProfile(customer.profile.id, submitData);
            console.log({saveCustomerProfileResponse : updatedProfile})
            customerProfileForm.reset(mapCustomerToProfileForm({internalProfile : updatedProfile}))
            handleClose();
            return updatedProfile;
        } catch(error) {
            console.warn('saveCustomerProfile failed : ', {error});
        }
    }

    async function onFromError(errors) {
        alert('Form data validation error.  Check console for details.')
        console.log('Form validation error ', errors)
    }

     const saveProfile = async () => {
        await customerProfileForm.handleSubmit(onFormSubmit, onFromError)()
        .catch((err) => {
            alert('Save data error.  CHeck console for details.')
            console.error('Save data error', err)
        })
    };
   
    return (
        <>
        <Dialog
        maxWidth="lg"
        open={openEditModal}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" style={{padding: '30px 24px'}}>
          <Typography variant="themeBlueHeadingRegular" style={{marginLeft: '4px'}}>{"Edit Profile"}</Typography>
          <hr style={{marginTop: '20px', color: '#D1CCCC'}}/>
        </DialogTitle>
        <DialogContent>
        <FormProvider {...customerProfileForm}>
                    <ProfileDetailsPanel customer={customer} />
                </FormProvider>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="secondary" onClick={handleClose} style={{textTransform: 'capitalize'}}>Cancel</Button>
          <Button variant="contained" color="primary" disabled={!isDirty} onClick={saveProfile} style={{textTransform: 'capitalize'}}>
            Save
          </Button>
        </DialogActions>
      </Dialog>

        <Stack direction="column" sx={{ mt: 2 }}>
            <PageHeading>
            <Stack
                sx={{ pr: 2 }}
                direction="row"
                flex={1}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
            >
                    <CustomerName variant="themeBlueHeading" customer={customer} prefix={"Customer Profile for"} />
                    <Button variant="outlined" onClick={handleOpen} style={{textTransform: 'capitalize', borderColor: useTheme().palette.text.primary, color: useTheme().palette.text.primary, fontFamily: 'gilroy-medium' }}>
                    Edit
                </Button>
                
            </Stack>
            </PageHeading>
            <PagePanel>
                <Grid container spacing={2}>
                    <Grid item xs={7}>
                        <Stack direction="column" spacing={2}>
                            <Stack direction="row" spacing={10} flex={1} style={{marginBottom: '15px'}}>
                                <Typography variant="detailsDataValue" style={{width: '120px', paddingRight: '26px'}}>Situation</Typography>
                                <Typography variant="detailsDataLabel" style={{width: '100%', textAlign: 'left'}}>{capitalizeString(customerProfileForm.getValues('lifeSituation').toLowerCase())}</Typography>
                            </Stack>
                            <Stack direction="row" spacing={10} flex={1} style={{marginBottom: '15px'}}>
                                <Typography variant="detailsDataValue" style={{width: '120px', paddingRight: '26px'}}>Life Stage</Typography>
                                <Typography variant="detailsDataLabel" style={{width: '100%', textAlign: 'left'}}>{capitalizeString(customerProfileForm.getValues('lifeStage').toLowerCase())}</Typography>
                            </Stack>
                            <Stack direction="row" spacing={10} flex={1} style={{marginBottom: '15px'}}>
                                <Typography variant="detailsDataValue" style={{width: '120px', paddingRight: '26px'}}>Location</Typography>
                                <Typography variant="detailsDataLabel" style={{width: '100%', textAlign: 'left'}}>{customer?.profile?.location?.cityName}, {customer?.profile?.location?.countryName}</Typography>
                            </Stack>

                            <Stack direction="row" spacing={10} flex={1} style={{marginBottom: '15px'}}>
                                <Typography variant="detailsDataValue" style={{width: '120px', paddingRight: '26px'}}>DOB</Typography>
                                <Typography variant="detailsDataLabel" style={{width: '100%', textAlign: 'left'}}>{moment(customer?.profile?.dateOfBirth).format('DD/MM/YYYY')}</Typography>
                            </Stack>

                            <Stack direction="row" spacing={10} flex={1} style={{marginBottom: '15px'}}>
                                <Typography variant="detailsDataValue" style={{width: '120px', paddingRight: '26px'}}>Interests</Typography>
                                <Stack direction="row" spacing={7} flex={1} style={{marginBottom: '5px', marginLeft: '0px', flexWrap: 'wrap', flexGrow: '1', maxWidth: '460px'}}>
                                    {isEmpty(visibleTags?.Interests) ? (
                                        <Typography variant="detailsDataLabel" style={{width: '100%', textAlign: 'left'}}>No interests selected</Typography>
                                    ) : (
                                        visibleTags?.Interests?.map((tag) => {
                                            if(!tag) return null;
                                            return (
                                            <Chip
                                                key={tag?.id || 0}
                                                label={tag?.name || 'None Assigned'}
                                                variant="filled"
                                                color='default'
                                                size="small"
                                                style={{marginBottom: '4px'}}
                                            />
                                            );
                                        })
                                    )}
                                </Stack>
                            </Stack>

                            <Stack direction="row" spacing={10} flex={1} style={{marginBottom: '15px'}}>
                                <Typography variant="detailsDataValue" style={{width: '120px', paddingRight: '26px'}}>Objectives</Typography>
                                <Stack direction="row" spacing={7} flex={1} style={{marginBottom: '5px', marginLeft: '0px', flexWrap: 'wrap', flexGrow: '1', maxWidth: '460px'}}>
                                {isEmpty(visibleTags?.Objectives) ? (
                                        <Typography variant="detailsDataLabel" style={{width: '100%', textAlign: 'left'}}>No objectives selected</Typography>
                                    ) : (
                                        visibleTags?.Objectives?.map((tag) => {
                                        if(!tag) return null;
                                        return (
                                        <Chip
                                            key={tag?.id || 0}
                                            label={tag?.name || 'None Assigned'}
                                            variant="filled"
                                            color='default'
                                            size="small"
                                            style={{marginBottom: '4px'}}
                                        />
                                        );
                                        })
                                    )}
                                </Stack>
                            </Stack>
                        </Stack>
                    </Grid>
                    <Grid item xs={5}>
                    <Stack direction="column" item xs={5}>
                            <Typography variant="greyedHeading">Notes</Typography>
                            <Box style={{
                                boxSizing: 'border-box',
                                height: '160px',
                                width: '438px',
                                border: '0.5px solid #D1CCCC',
                                borderRadius: '2px',
                                backgroundColor: '#FFFFFF',
                                marginTop: '8px',
                                padding: '12px',
                                fontSize: '12px',
                            }}>
                                {customerProfileForm.getValues('internalProfileNotes').toLowerCase()}
                            </Box>
                    </Stack>
                    </Grid>
                </Grid>
            </PagePanel>
        </Stack>
        </>
    );
}

function capitalizeString(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

function parseTagsToString(tags) {
    try {
        const tagString = JSON.stringify(tags);
        console.log('MEXparseTagsToString', { tags, tagString });
        return tagString;
    } catch(error) {
        console.warn('Failed converting tags to string : ', {tags, error});
    }
}

function parseStringToTags(tagString = '{}') {
    try {
        console.log({MEX : tagString})
        const tags = JSON.parse(tagString);
        console.log({MEXparseStringToTags : { tagString, tags} })
        return {
            'Interests' : tags.Interests,
            'Objectives' : tags.Objectives,
        }
    } catch (error) {
        console.warn('Invalid tag string for customer : ', { tagString, error} )
        return {};
    }
}

function ProfileDetailsPanel({ customer }) {
    console.log('profile panel render')

    // const [displayLocation, setDisplayLocation] = React.useState('');
    // const [dateOfBirth, setDateOfBirth] = React.useState('N/A');

    // React.useEffect(() => {
    //     setDisplayLocation(
    //         customer.profile.location?.cityName + ', ' + customer.profile.location?.countryName || 'N/A'
    //     );
    //     setDateOfBirth(
    //         customer.profile.dateOfBirth ? moment(customer.profile.dateOfBirth).format('DD MMM YYYY') : 'N/A'
    //     );
    // }, [customer])


    return (
        
            <Stack direction="row" flex={1} sx={{ pr: 2 }}>
                <Grid container rowSpacing={2} columnSpacing={4} flex={1}>
                    <Grid item xs={3}>
                        <InputLabel id="customer-profile-situation-label"><Typography variant="detailsDataLabel">Situation</Typography></InputLabel>
                        <Controller name="lifeSituation" render={({ field }) => {
                            console.log('render select', {field});
                            return (
                            <Select 
                                {...field}
                                fullWidth
                                id="customer-profile-situation"
                                displayEmpty
                                labelId="customer-profile-situation-label"
                            >
                                <MenuItem value={''}>-- Not Set --</MenuItem>
                                <MenuItem value={'SOLO'}>Solo</MenuItem>
                                <MenuItem value={'COUPLE'}>Couple</MenuItem>
                                <MenuItem value={'OTHER'}>Other</MenuItem>
                            </Select>)}}/>
                    </Grid>
                    <Grid item xs={3}>
                        <InputLabel id="customer-profile-stage-label"><Typography variant="detailsDataLabel">Life Stage</Typography></InputLabel>
                        <Controller name="lifeStage" render={({ field }) => (
                            <Select
                                {...field}
                                fullWidth
                                id="customer-profile-stage"
                                displayEmpty
                                labelId="customer-profile-stage-label"
                            >
                                <MenuItem value={''}>-- Not Set --</MenuItem>
                                <MenuItem value={'SINGLE'}>Single</MenuItem>
                                <MenuItem value={'MARRIED'}>Married</MenuItem>
                                <MenuItem value={'RETIRED'}>Retired</MenuItem>
                            </Select>)}/>
                    </Grid>
                    {/* <Grid item xs={3}>
                        <InputLabel id="customer-profile-location-label"><Typography variant="detailsDataLabel">Location</Typography></InputLabel>
                        <TextField fullWidth readOnly value={displayLocation} />
                    </Grid>
                    <Grid item xs={3}>
                        <InputLabel id="customer-profile-location-label"><Typography variant="detailsDataLabel">Date Of Birth</Typography></InputLabel>
                        <TextField fullWidth readOnly value={dateOfBirth} />
                    </Grid> */}
                    <Grid item xs={6}>
                    <Controller name="tags" render={({ field }) => (
                        <TagEditor selectedTags={field.value} updateTags={field.onChange} />
                    )}/>
                    </Grid>
                    <Grid item xs={6} display="flex"
                        flexDirection="column">
                            <Typography variant="greyedHeading">Notes</Typography> 
                            <Controller
                                name="internalProfileNotes"
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        style={{  boxSizing: 'border-box',
                                        height: '160px',
                                        borderRadius: '2px',
                                        backgroundColor: '#FFFFFF',
                                        marginTop: '8px',
                                        fontSize: '12px', }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        multiline
                                        minRows={5}
                                        maxRows={5}
                                        defaultValue={customer?.internalProfile?.internalProfileNotes}
                                    />
                                )}
                            />
                    </Grid>
                </Grid>
            </Stack>
    );
}
